import { useStyles, Grid, Label } from '@archipro-design/aria';
import { ArticleTileSkeletonDesktop } from './ArticleTileSkeleton.desktop';
import * as S from '../articles-carousel/ArticlesCarousel.style';

interface ArticleCarouselPlaceholderProps {
    title: string;
}
export const ArticleCarouselPlaceholderDesktop: React.FC<
    ArticleCarouselPlaceholderProps
> = ({ title }) => {
    const { css } = useStyles();

    return (
        <div className={css(S.SliderWrap)}>
            <Label className={css(S.TitleWrap)} variant="01">
                {title}
            </Label>
            <Grid className={css(S.PlaceholderGrid)} columns={'3'}>
                <ArticleTileSkeletonDesktop />
                <ArticleTileSkeletonDesktop />
                <ArticleTileSkeletonDesktop />
            </Grid>
        </div>
    );
};
